import * as React from 'react';
import formatters from '../formatters';
import {
  optimizationsCountAsPercentage,
  optimizationsRevenueAsPercentage,
} from './common';

export function optimizationsLoyalistsCountAsPercentage(
  benchmark: number,
  value: number,
  score: number
): string | any {
  return optimizationsCountAsPercentage(benchmark, value, score);
}

export function optimizationsLoyalistsRevenueAsPercentage(
  benchmark: number,
  value: number,
  score: number
): string | any {
  return optimizationsRevenueAsPercentage(benchmark, value, score);
}

export function optimizationsLoyalistsMigrationForward(
  benchmark: number,
  value: number,
  score: number
): string | any {
  if (value > benchmark) {
    return [
      {
        text: `Segment Migration (L>CH) Rate ${formatters.percent.format(
          value
        )}, ${formatters.count.format(
          (value - benchmark) * 100
        )} points above benchmark`,
        negative: false,
      },
    ];
  } else {
    return [
      {
        text: `Segment Migration (L>CH) Rate ${formatters.percent.format(
          value
        )}, ${formatters.count.format(
          (benchmark - value) * 100
        )} points below benchmark`,
        negative: true,
      },
    ];
  }
}

export function optimizationsLoyalistsIndValue(
  benchmark: number,
  value: number,
  score: number
): string | any {
  if (value > benchmark) {
    return [
      {
        text: `Individual Segment Customer Value ${formatters.count.format(
          value
        )}x, ${benchmark} points above benchmark`,
        negative: false,
      },
    ];
  } else {
    return [
      {
        text: `Individual Segment Customer Value ${formatters.count.format(
          value
        )}x Casuals, benchmark is ${benchmark}x`,
        negative: true,
      },
    ];
  }
}
